export const containerConfig = {
  small: {
    maxWidth: "max-w-md",
    margin: "mt-4",
  },
  medium: {
    maxWidth: "max-w-2xl",
    margin: "mt-8",
  },
  large: {
    maxWidth: "max-w-4xl",
    margin: "mt-10",
  },
  xlarge: {
    maxWidth: "max-w-6xl",
    margin: "mt-12",
  },
};
